import { Stack } from "@mui/material";
import { VehicleCard } from "@app/components";
import { ProductsListsCardsProps } from "../types";

const ProductListCards = ({
  filteredData,
  selectedCardId,
  onSelect,
  onViewDetails,
  isMobile,
}: ProductsListsCardsProps) => {
  return (
    <Stack
      flexWrap="wrap"
      justifyContent={isMobile ? "center" : "flex-start"}
      alignItems="center"
      gap={isMobile ? 1 : 2}
      direction="row"
      sx={{
        flex: 1,
        px: 2,
        mb: 1.8,
      }}
    >
      {filteredData?.map((item: any) => (
        <VehicleCard
          key={item?.id}
          vehicle={item}
          selectedCardId={selectedCardId}
          onSelect={() => onSelect(item?.id)}
          onViewDetails={onViewDetails}
        />
      ))}
    </Stack>
  );
};

export { ProductListCards };
